import { TFunction } from "i18next";

import { EventTypeCellParts, EventTypeStrategy } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";
import { formatCurrency } from "@/utils/valueFormat";

export class MonthlyBudgetEventTypeStrategy implements EventTypeStrategy {
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    const previousAmountText = row.eventData.previousAmount ? (
      <>
        {" | "}
        {t("common.previous")} {t("common.amount")}:{" "}
        <b>{formatCurrency(row.eventData.previousAmount)}</b>
      </>
    ) : (
      ""
    );
    return (
      <>
        {t(`eventTypes.${row.eventType}`)}
        {previousAmountText}
      </>
    );
  }

  getTypeAndDescription(
    row: TransactionType,
    t: TFunction
  ): EventTypeCellParts {
    const previousAmount = row.eventData.previousAmount;

    const parts: (string | JSX.Element)[] = [];

    if (previousAmount !== null && previousAmount !== undefined) {
      parts.push(
        <>
          {t("common.previous")} {t("common.amount")}:{" "}
          <b>{formatCurrency(previousAmount)}</b>
        </>
      );
    }

    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: <>{parts}</>,
    };
  }
}
